'use strict';

exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/history/lib/ExecutionEnvironment.js
// module id = V2vc
// module chunks = 1